import { Group } from 'three';
import { Rng } from '../../core/rng';
import { stopAt } from '../../systems/passengers/stopSequence';
import { animateWalk, createPerson, type Person } from '../people/personModel';
import { LAYOUT } from './roadLayout';

const MAX_PEOPLE = 10;

/** Where crowd member `slot` stands at stop `seq`, in world coordinates. Shared with the walkers. */
export function crowdSpot(seq: number, slot: number): { x: number; z: number; rotY: number } {
  const rng = new Rng(seq * 31 + slot * 7 + 7);
  const z = -stopAt(seq).position + 4 - slot * 0.9 + rng.range(-0.3, 0.3);
  return { x: LAYOUT.sidewalkX - 1 + rng.range(-0.6, 1.4), z, rotY: -Math.PI / 2 + rng.range(-0.5, 0.5) };
}

/** People waiting at the current stop. The crowd thins out as they walk to the trotro. */
export class Crowd {
  readonly group = new Group();
  private readonly people: Person[] = [];
  private seq = -1;
  private clock = 0;

  constructor() {
    for (let i = 0; i < MAX_PEOPLE; i += 1) {
      const person = createPerson(i * 13 + 1);
      this.people.push(person);
      this.group.add(person.root);
    }
  }

  invalidate(): void {
    this.seq = -1;
  }

  update(seq: number, waiting: number, dt: number): void {
    this.clock += dt;
    if (seq !== this.seq) {
      this.seq = seq;
      this.people.forEach((person, i) => {
        const spot = crowdSpot(seq, i);
        person.root.position.set(spot.x, 0.2, spot.z);
        person.root.rotation.y = spot.rotY;
      });
    }
    this.people.forEach((person, i) => {
      person.root.visible = i < waiting;
      // Small idle sway so the crowd doesn't look frozen.
      person.arms[0].rotation.x = Math.sin(this.clock * 1.3 + i) * 0.08;
      animateWalk(person, 0, 0);
      person.root.position.y = 0.2;
    });
  }
}
